import React from 'react';
import { Clock } from 'lucide-react';

export const BlogMeta = ({ published, readMinutes, dark = false }) => {
  const formattedDate = new Date(published).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  const textClass = dark ? 'text-slate-300' : 'text-slate-500';
  const iconStroke = dark ? '#cbd5e1' : '#94a3b8';

  return (
    <div className={`flex flex-wrap items-center gap-4 mb-4 ${textClass}`}>
      <time dateTime={published} className="flex items-center gap-1.5 text-sm">
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="1" y="2" width="14" height="13" rx="2" stroke={iconStroke} strokeWidth="1.5"/>
          <path d="M5 1v2M11 1v2M1 6h14" stroke={iconStroke} strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        {formattedDate}
      </time>
      <span className="flex items-center gap-1.5 text-sm">
        <Clock size={14} />
        {readMinutes} min read
      </span>
    </div>
  );
};
